<form [formGroup]="penFormGroup">
  <div class="flex--column">
    <h3>{{ 'tail-biting.detail.pen' | translate }} {{ index + 1 }}</h3>
    <mat-form-field class="flex__child--auto spacing--margin-top penage">
      <mat-label>{{ 'tail-biting.detail.label.age' | translate }}</mat-label>
      <input
        matInput
        formControlName="tailBitingAge"
        placeholder="{{ 'tail-biting.detail.label.age' | translate }}"
        data-test="tail-biting-detail__age"
      />
      <span matTextSuffix class="form-field-suffix--text">{{
        'tail-biting.detail.label.days' | translate
      }}</span>
      <mat-error *ngIf="penFormGroup.controls.tailBitingAge.invalid">
        {{ 'tail-biting.detail.error-age' | translate }}</mat-error
      >
    </mat-form-field>
  </div>

  <div class="spacing--margin-top">
    <div class="spacing--margin-top flex--row flex--wrap">
      <div class="flex--column">
        <h3>
          {{ 'tail-biting.detail.label.tailLengthType' | translate }}
          <mat-icon [matTooltip]="getToolTip('tail-biting.detail.tailLengthType.hint')"
            >info_outline</mat-icon
          >
        </h3>
      </div>
    </div>
  </div>

  <div class="flex--column spacing--padding-right">
    <mat-form-field class="flex__child--auto">
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="{{ 'tail-biting.detail.label.tailLengthType' | translate }}"
        formControlName="tailLength"
        data-test="tail-biting__tail-length"
      >
        <mat-option *ngFor="let tailLengthType of tailLengthTypes" [value]="tailLengthType">
          {{ 'tail-biting.detail.tailLengthType.' + tailLengthType | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="spacing--margin-top" *ngIf="showTailPositionType">
    <div class="spacing--margin-top flex--row flex--wrap">
      <div class="flex--column">
        <h3>
          {{ 'tail-biting.detail.label.tailPositionType' | translate }}
          <mat-icon [matTooltip]="getToolTip('tail-biting.detail.tailPositionType.hint')"
            >info_outline</mat-icon
          >
        </h3>
      </div>
    </div>
  </div>

  <div class="flex--column spacing--padding-right" *ngIf="showTailPositionType">
    <mat-form-field class="flex__child--auto">
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="{{ 'tail-biting.detail.label.tailPositionType' | translate }}"
        formControlName="tailPosition"
        data-test="tail-biting__tail-position"
      >
        <mat-option *ngFor="let tailPositionType of tailPositionsTypes" [value]="tailPositionType">
          {{ 'tail-biting.detail.tailPositionType.' + tailPositionType | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="spacing--margin-top">
    <div class="spacing--margin-top flex--row flex--wrap">
      <div class="flex--column">
        <h3>
          {{ 'tail-biting.detail.label.tailDamageType' | translate }}
          <mat-icon [matTooltip]="getToolTip('tail-biting.detail.tailDamageType.hint')"
            >info_outline</mat-icon
          >
        </h3>
      </div>
    </div>
  </div>

  <div class="flex--column spacing--padding-right">
    <mat-form-field class="flex__child--auto">
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="{{ 'tail-biting.detail.label.tailDamageType' | translate }}"
        formControlName="tailDamage"
        data-test="tail-biting__tail-damage"
      >
        <mat-option *ngFor="let tailDamageType of tailDamageTypes" [value]="tailDamageType">
          {{ 'tail-biting.detail.tailDamageType.' + tailDamageType | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="spacing--margin-top" *ngIf="showTailFreshnessType">
    <div class="spacing--margin-top flex--row flex--wrap">
      <div class="flex--column">
        <h3>
          {{ 'tail-biting.detail.label.freshnessType' | translate }}
          <mat-icon [matTooltip]="getToolTip('tail-biting.detail.tailFreshnessType.hint')"
            >info_outline</mat-icon
          >
        </h3>
      </div>
    </div>
  </div>

  <div class="flex--column spacing--padding-right" *ngIf="showTailFreshnessType">
    <mat-form-field class="flex__child--auto">
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="{{ 'tail-biting.detail.label.freshnessType' | translate }}"
        formControlName="freshness"
        data-test="tail-biting__fresh-ness-type"
      >
        <mat-option *ngFor="let freshnessType of freshnessTypes" [value]="freshnessType">
          {{ 'tail-biting.detail.tailFreshnessType.' + freshnessType | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="flex--column spacing--margin-bottom deletebutton spacing--margin-top">
    <button
      *ngIf="canDelete"
      mat-flat-button
      color="primary"
      color="warn"
      (click)="delete()"
      data-test="create-tail-biting__delete-pen"
    >
      <mat-icon>delete</mat-icon>{{ 'tail-biting.detail.delete-pen' | translate }}
    </button>
  </div>
</form>
